<template>
  <div>
    <section class="section is-main-section">
      <CardComponent>
        <div class="section has-text-centered">
          <h1 class="title">Manage Packages</h1>
          <div class="has-text-right">
            <b-button
              type="is-primary"
              icon-left="plus"
              tag="router-link"
              :to="{ name: 'CreatePackage' }"
              >Add</b-button
            >
          </div>
          <b-field class="has-margin-top-15">
            <b-input
              v-model="search"
              placeholder="Search..."
              type="search"
              icon="magnify"
            >
            </b-input>
          </b-field>
          <b-table
            :data="filteredPackages"
            :bordered="false"
            :striped="true"
            :narrowed="true"
            :hoverable="true"
            :loading="loading"
            :focusable="false"
            :mobile-cards="true"
            :paginated="true"
          >
            <template slot-scope="props">
              <b-table-column field="" label="" width="40" numeric>
                <img
                  v-if="props.row.image && props.row.image"
                  :src="props.row.image"
                />
              </b-table-column>

              <b-table-column field="title" label="Title">
                <router-link
                  :to="{ name: 'PackageDetail', params: { id: props.row.id } }"
                  >{{ props.row.title }}</router-link
                >
              </b-table-column>

              <b-table-column field="active" label="Active">
                <b-icon v-if="isActive(props.row)" icon="check"></b-icon>
                <b-icon v-if="!isActive(props.row)" icon="close"></b-icon>
              </b-table-column>

              <b-table-column class="has-text-centered">
                <b-dropdown aria-role="list">
                  <button slot="trigger" class="button is-primary">
                    <span>Actions</span>
                    <b-icon icon="menu-down"></b-icon>
                  </button>

                  <b-dropdown-item aria-role="listitem" :has-link="true"
                    ><router-link
                      :to="{
                        name: 'EditPackage',
                        params: { id: props.row.id }
                      }"
                      >Edit</router-link
                    ></b-dropdown-item
                  >
                  <b-dropdown-item
                    aria-role="listitem"
                    @click="confirmDelete(props.row)"
                    >Delete</b-dropdown-item
                  >
                </b-dropdown>
              </b-table-column>
            </template>

            <template slot="empty">
              <section class="section">
                <div class="content has-text-grey has-text-centered">
                  <p>
                    <b-icon icon="emoticon-sad" size="is-medium"> </b-icon>
                  </p>
                  <p>No packages yet.</p>
                </div>
              </section>
            </template>
          </b-table>
        </div>
      </CardComponent>
    </section>
    <b-modal
      :active.sync="showConfirmModal"
      trap-focus
      aria-role="dialog"
      aria-modal
      has-modal-card
      @close="showConfirmModal = false"
    >
      <div class="modal-card" style="width: auto">
        <header class="modal-card-head">
          <p class="modal-card-title">Confirm Delete?</p>
        </header>
        <section class="modal-card-body">
          Are you sure you want to delete this package?
        </section>
        <footer class="modal-card-foot" style="justify-content: flex-end;">
          <button
            class="button"
            type="button"
            @click="showConfirmModal = false"
          >
            No
          </button>
          <button class="button is-primary" @click.prevent="deleteTitle()">
            Yes
          </button>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CardComponent from '@/components/CardComponent'
import PackageApi from '@/api/packages'
export default {
  name: 'ManagePackages',
  components: {
    CardComponent
  },
  metaInfo: {
    title: 'Manage Packages'
  },
  computed: {
    ...mapGetters(['user']),
    filteredPackages() {
      if (this.search !== '' && this.packages.length > 0) {
        let query = this.search.toLowerCase()
        return this.packages.filter(item =>
          item.title.toLowerCase().includes(query)
        )
      } else {
        return this.packages
      }
    }
  },
  created() {
    this.fetchPackages()
  },
  data() {
    return {
      loading: true,
      packages: [],
      search: '',
      showConfirmModal: false,
      item: {}
    }
  },
  methods: {
    ...mapActions(['getUser']),
    isActive(item) {
      return item && item.active === 1
    },
    confirmDelete(item) {
      this.showConfirmModal = true
      this.item = item
    },
    deleteTitle() {
      PackageApi.remove({
        packageId: this.item.id
      })
        .then(() => {
          this.$buefy.toast.open({
            message: 'Package deleted successfully!',
            position: 'is-top',
            type: 'is-success'
          })
          this.fetchPackages()
          this.showConfirmModal = false
          this.loading = false
        })
        .catch(err => {
          console.log(err)
          this.$buefy.toast.open({
            message: 'Error deleting package',
            position: 'is-top',
            type: 'is-danger'
          })
          this.loading = false
        })
    },
    fetchPackages() {
      this.loading = true
      PackageApi.getAll().then(packages => {
        this.packages = packages
        this.loading = false
      })
    }
  }
}
</script>
